const headerSearchToggleButton = document.querySelector(
  "button.btn-toggle-search"
);
const headerSearchCloseButton = document.querySelector(".close-search");
const globalSearchBar = document.querySelector("div.global-search-bar");

let headerExpand = () => {
  if (globalSearchBar.classList.contains("closed")) {
    globalSearchBar.classList.toggle("closed");
    globalSearchBar.classList.toggle("show");
  } else {
    globalSearchBar.classList.toggle("show");
  }
};
let headerClose = () => {
  globalSearchBar.classList.toggle("closed");
  globalSearchBar.classList.toggle("show");
};

document.addEventListener("DOMContentLoaded", () => {
  headerSearchToggleButton.addEventListener("click", headerExpand);
  headerSearchCloseButton.addEventListener("click", headerClose);
});
